import { useMemo, useState } from "react";
import {
  Modal, Box, Typography, IconButton, Grid, TextField
} from "@mui/material";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';

const modalStyle = {
  bgcolor: "background.paper",
  boxShadow: 24,
  left: "50%",
  maxWidth: "980px",
  maxHeight: "680px",
  overflow: "scroll",
  p: 4,
  position: "absolute",
  top: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%"
};

const ContractNewsTasksModal = ({ open, contract, onClose }) => {
  const [localTasks, setLocalTasks] = useState([]);
  const [inputTask, setInputTask] = useState('');

  const tasks = useMemo(() => {
    const tmpTasks = [...contract.tasks];

    localTasks.forEach((task) => {
      switch (task.action) {
        case 'ADD':
          tmpTasks.push(task);
          break;
        case 'DELETE':
          const idxTask = tmpTasks.findIndex(t => t.title === task.title);
          if (idxTask !== -1) {
            tmpTasks.splice(idxTask, 1);
          }
          break;
        default:
          break;
      }
    });

    return tmpTasks;
  }, [contract, localTasks]);

  const handleAdd = () => {
    if (!inputTask) return;
    const task = { title: inputTask, followup: true, action: 'ADD' };
    setLocalTasks((prev) => ([task, ...prev]));

    setInputTask('');
  };

  const handleDelete = (task) => {
    if (task.action) {
      const tmpLocalTasks = [...localTasks];
      const idxTask = tmpLocalTasks.findIndex(t => t.title === task.title);
      if (idxTask !== -1) {
        tmpLocalTasks.splice(idxTask, 1);
        setLocalTasks(tmpLocalTasks);
      }
    } else {
      const tmpTasks = [...contract.tasks];
      const idxTask = tmpTasks.findIndex(t => t.title === task.title);
      const tmpTask = { ...contract.tasks[idxTask], action: 'DELETE' };
      setLocalTasks((prev) => ([...prev, tmpTask]));
    }
  };

  return (
    <Modal
      open={open}
      onClose={() => onClose(localTasks)}
    >
      <Box sx={modalStyle}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Typography variant="h6" sx={{ flex: 1 }}>Obligaciones del contratista</Typography>
          <CloseIcon sx={{ cursor: 'pointer' }} onClick={() => onClose(localTasks)} />
        </Box>
        <Box sx={{ display: "flex", my: 2, backgroundColor: "#efefef", p: 2, borderRadius: 2 }}>
          <TextField
            fullWidth
            label="Escribe la obligación del contratista"
            size="small"
            value={inputTask}
            onChange={(evt) => setInputTask(evt.currentTarget.value)}
          />
          <IconButton onClick={handleAdd}>
            <AddCircleOutlineIcon />
          </IconButton>
        </Box>
        <Grid container spacing={1} sx={{ textAlign: "center", my: 1 }}>
          <Grid item xs={10}>
            <Typography variant="h6">Obligación</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography variant="h6">Acciones</Typography>
          </Grid>
        </Grid>

        {tasks.map((task, idx) => (
          <Grid container key={idx} sx={{
            border: 'thin solid lightgray',
            padding: 1,
            my: 1,
            textAlign: "center"
          }}>
            <Grid item xs={11} sx={{ textAlign: "left" }}>{task.title}</Grid>
            <Grid item xs={1}>
              <IconButton onClick={() => handleDelete(task)}>
                <DeleteIcon />
              </IconButton>
            </Grid>
          </Grid>
        ))}
      </Box>
    </Modal>
  );
};

export default ContractNewsTasksModal;
